import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ToastService} from "@shared/services/toast.service";

@Injectable({
  providedIn: 'root'
})
export class EcommerceService {


  constructor(private http: HttpClient, private toast: ToastService) {
  }

  // products
  public getProducts(params: any) {
    let urlParams = '';
    const size = 'len=5';
    Object.keys(params).forEach((key) => {
      urlParams = urlParams + '&' + key + '=' + params[key];
    });
    let url = 'web/ecommerce/products?' + size + urlParams;
    return this.http.get(url);
  }

  public getAllCategories() {
    return this.http.get('web/ecommerce/categories');
  }

  public getProduct(id: any) {
    return this.http.get('web/ecommerce/products/'+ id);
  }

  public createProduct(product: any) {
    return this.http.post('web/ecommerce/products', product);
  }

  public editProduct(product: any, id: any) {
    return this.http.put('web/ecommerce/products/'+ id, product);
  }

  public deleteProduct(id: any) {
    return this.http.delete('web/ecommerce/products/'+ id);
  }

  // Categories
  public getCategories(params: any) {
    let urlParams = '';
    const size = 'len=5';
    Object.keys(params).forEach((key) => {
      urlParams = urlParams + '&' + key + '=' + params[key];
    });
    let url = 'web/ecommerce/categories?' + size + urlParams;
    return this.http.get(url);
  }

  public getCategory(id: any) {
    return this.http.get('web/ecommerce/categories/'+ id);
  }

  public createCategory(category: any) {
    return this.http.post('web/ecommerce/categories', category);
  }

  public editCategory(category: any, id: any) {
    return this.http.put('web/ecommerce/categories/'+ id, category);
  }

  public deleteCategory(id: any) {
    return this.http.delete('web/ecommerce/categories/'+ id);
  }

  // Orders

  public getOrders(params: any) {
    let urlParams = '';
    const size = 'len=5';
    Object.keys(params).forEach((key) => {
      urlParams = urlParams + '&' + key + '=' + params[key];
    });
    let url = 'web/ecommerce/orders?' + size + urlParams;
    return this.http.get(url);
  }

  public getOrderById(id: any) {
    return this.http.get('web/ecommerce/orders/'+ id);
  }

  public getOrderItemsById(id: any) {
    return this.http.get('web/ecommerce/orders/'+ id + '/items');
  }

  public getOrdersStats(params: any) {
    let urlParams = '';
    const size = 'len=5';
    Object.keys(params).forEach((key) => {
      urlParams = urlParams + '&' + key + '=' + params[key];
    });
    let url = 'web/ecommerce/orders/stat?' + size + urlParams;
    return this.http.get(url);
  }

  public getOrder(id: any) {
    return this.http.get('web/ecommerce/orders/'+ id);
  }

  public updateOrderStatus(id: string, status: string) {
    return this.http.put(`store-users/branch-orders/${id}`, { status });
  }

}
